// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a5af56ac","124":"f096ccb7","164":"cfd95337","296":"00cdcf7b","330":"a8103b4d","453":"4fbad7c7","501":"1ca094cf","656":"03c6a7e1","671":"46fe8afe","898":"0a4ad88d","956":"1d88e9fb"}[chunkId] + ".chunk.js";
};